var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.292 15.146l-5.25-5.23a4.709 4.709 0 01-1.438.813 4.899 4.899 0 01-1.667.292c-1.43 0-2.638-.493-3.625-1.48C1.326 8.557.833 7.348.833 5.918c0-1.417.493-2.622 1.48-3.615.986-.993 2.194-1.49 3.624-1.49 1.417 0 2.618.494 3.605 1.48.986.986 1.479 2.194 1.479 3.625 0 .597-.098 1.166-.292 1.708a4.678 4.678 0 01-.792 1.417l5.23 5.229-.875.875zM5.937 9.77c1.07 0 1.976-.375 2.72-1.125.742-.75 1.114-1.66 1.114-2.73 0-1.069-.372-1.979-1.114-2.729-.744-.75-1.65-1.124-2.72-1.124-1.083 0-1.996.374-2.739 1.124-.743.75-1.115 1.66-1.115 2.73s.372 1.979 1.115 2.729S4.854 9.77 5.938 9.77z",
    fill: "url(#search_svg__paint0_linear_176_8742)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "search_svg__paint0_linear_176_8742",
    x1: 7.87,
    y1: 0.813,
    x2: 10.193,
    y2: 14.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0D260"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#A06F15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopColor: "#D4A73D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17203"
  })))));
}
export default SvgSearch;